import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createBranchVersion } from "../api/create-branch-version";
import { updateBranchVersion, updateBranchVersionActive } from "../api/update-branch-version";
import { BRANCH_VERSIONS_QUERY_KEY } from "./use-branch-versions";

export function useCreateBranchVersion(branchUid: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: {
      name: string;
      description: string;
      validFrom: string;
      validTo: string;
      baseBranchVersionId?: number;
      setCameraTypeDefault: boolean;
      isActive?: boolean;
    }) => {
      if (!branchUid) throw new Error("branchUid is required");
      return createBranchVersion({ branchUid, ...params });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BRANCH_VERSIONS_QUERY_KEY, branchUid] });
    },
  });
}

export function useUpdateBranchVersion(branchUid: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: {
      branchVersionId: number;
      name: string;
      description: string;
      validFrom: string;
      validTo: string;
    }) => {
      if (!branchUid) throw new Error("branchUid is required");
      return updateBranchVersion({ branchUid, ...params });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BRANCH_VERSIONS_QUERY_KEY, branchUid] });
    },
  });
}

export function useUpdateBranchVersionActive(branchUid: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: {
      branchVersionId: number;
      isActive: boolean;
    }) => {
      if (!branchUid) throw new Error("branchUid is required");
      return updateBranchVersionActive({ branchUid, ...params });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BRANCH_VERSIONS_QUERY_KEY, branchUid] });
    },
  });
}
